
import { Component } from '@angular/core';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';
import { RoutingService } from '@spartacus/core';

@Component({
  selector: 'request-login',
  standalone: true,
  imports: [],
  templateUrl: './request-login.component.html',
  styleUrl: './request-login.component.scss',
})
export class RequestLoginComponent {
  constructor(
    private modalService: ModalService,
    private routingService: RoutingService,
  ) {}

  loginHandler() {
    this.modalService.close();
    this.routingService.go(['login']);
  }
}
